// trimFinalPathComponent trims the final /-delimited component off the given location (URL) string.
export default function trimFinalPathComponent(loc: string, numComponentsToTrim = 1): string {
  const delim = "/";
  const parts = loc.split(delim);
  return parts.slice(0, parts.length - numComponentsToTrim).join(delim) || "/";
}
